import { Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

export default function ProductOrderIdCell({
  orderId,
  orderNumber,
  detailBasePath,
}) {
  if (!orderNumber) return "-";

  if (detailBasePath && orderId) {
    return (
      <Link
        component={RouterLink}
        to={`${detailBasePath}/${orderId}`}
        underline="hover"
        color="primary"
        sx={{ fontWeight: 600, fontSize: "inherit" }}
      >
        {orderNumber}
      </Link>
    );
  }

  return orderNumber;
}
